// extracted by mini-css-extract-plugin
export var pillWrapper = "_n1-0";
export var showOverflow = "_n1-1";